import React from "react";
import { renderFooter } from "@amitasoft/site-shell";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  return (
    <div
      className="as-shell-mount"
      dangerouslySetInnerHTML={{ __html: renderFooter({ currentPath: location.pathname }) }}
    />
  );
}
